import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export type ReportPageHeadingProps = {
  title: string;
  /** e.g. company name */
  subtitle?: ReactNode;
  /** Pre-formatted period line, e.g. "From 10 Nov 2025 to 16 Nov 2025" */
  periodLabel?: ReactNode;
};

/**
 * Centered report title block: main title, optional subtitle, optional period line.
 */
const ReportPageHeading = ({
  title,
  subtitle,
  periodLabel,
}: ReportPageHeadingProps) => {
  return (
    <Box textAlign="center" py={2}>
      <Stack spacing={0.5} alignItems="center">
        <Typography
          component="h1"
          fontWeight={700}
          fontSize={{ xs: "24px", sm: "30px" }}
          color="#101828"
        >
          {title}
        </Typography>
        {subtitle != null && (
          <Typography fontSize="18px" color="text.secondary" fontWeight={500}>
            {subtitle}
          </Typography>
        )}
        {periodLabel != null && (
          <Typography fontSize="15px" color="text.secondary" sx={{ mt: 0.5 }}>
            {periodLabel}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default ReportPageHeading;
